import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';
import statusLogged, { IStatusLogged } from './statusLogged';
import visitable, { IVisitable } from './visitable';

export interface IChangeOrder extends IModel, IStatusLogged, IVisitable {
	accountingId?: string;
	adjustedSellPrice?: number;
	name?: string;
	description?: string;
	transactionAccount?: string;
	type?: 'change-order' | 'billing-adjustment';
	isContract?: boolean;
	isClosed?: boolean;
	allowedContractEdits: 'changes' | 'none';
}

const changeOrderFactory = modelFactory.createFactory<IChangeOrder>('ChangeOrder', _.assign({}, model, visitable, statusLogged('unlocked'), {
	accountingId: {},
	adjustedSellPrice: {
		setFilters: valueFilters.cleanNumber,
		getFilters: valueFilters.toNumber,
		rules: [
			(value, target) => {
				if (['billing-adjustment'].indexOf(target.type) !== -1) {
					return (value !== 0) || 'Amount is required';
				}
			}
		]
	},
	name: {
		setFilters: valueFilters.toString,
		rules: validator.string()
	},
	description: {
		setFilters: valueFilters.toString,
		rules: validator.string()
	},
	transactionAccount: {
		setFilters: valueFilters.toString,
		rules: validator.string()
	},
	type: {
		setFilters: valueFilters.toString
	},
	isContract: {
		writable: false,
		nonSerialized: true
	},
	_get_isContract: function () {
		return !!this.getMostRecentStatusByStatus('approved');
	},
	allowedContractEdits: {
		writable: false,
		nonSerialized: true
	},
	_get_allowedContractEdits: function () {
		return ['unlocked', 'rejected'].indexOf(this.currentStatus) !== -1 ? 'changes' : 'none';
	},
	isClosed: {
		writable: false,
		nonSerialized: true
	},
	_get_isClosed: function () {
		return (['closed'].indexOf(this.currentStatus) !== -1 || this.isContract)
	},
}));

export default changeOrderFactory;